import React from "react";
import DefaultCard from "./default-card";
import {loginUrl} from '../constants';
import ucaEnv from "../../../../common/env/env-uca";
import { useApi } from "../../../../hooks";
import { CommonModule } from "uca-react-containers-library";
import PaymentsSvg from "../icons/payments.svg";
import FreshPasssSvg from "../icons/freshPass.svg";

const PaymentDetailCard = ({ banner, category }) => {
    const { appData: { env, platform } } = CommonModule.useApp();
    const environmentVariables = ucaEnv(banner, env, platform);
    const { data } = useApi(`${environmentVariables.REWARDS_PAGE_BASE_API}/customer/payment/methods`) || {};
    const paymentMethods = data ? data.paymentMethods : null;

    if(paymentMethods && paymentMethods.length > 0) {
        const cardArray = [];
        paymentMethods.forEach(methods => {
            const title = methods.purpose === "DELIVERY_SUBSCRIPTION" ?
                            'FreshPass™ payment' :
                                methods.purpose === 'AUTO_REPLENISHMENT' ? 'Schedule & Save' : 'Shop payment';
            const desc = `${methods.cardType} ******${methods.maskedNumber}`;
            const link = {
                href: '/customer-account/payment.html',
                label: 'Update card'
            };
            const image=  methods.purpose === "DELIVERY_SUBSCRIPTION" ? FreshPasssSvg : PaymentsSvg;
            cardArray.push(<DefaultCard category={{...category, title, desc, link, image }} />);
        });
        return cardArray;
    }
    return <DefaultCard category={category} />;
};

export default PaymentDetailCard;
